<template>
  <md-card>
    <div class="card">
      <md-button
          class="md-dense md-raised md-secondary"
          @click="goBack"
      >
        <md-icon>arrow_back</md-icon>
        Go Back
      </md-button>

      <md-card-header>
        <items-view :title="'Guidance Details: ' + guidance.name">
          <item-view label="Guidance Number" :value="guidance.guidance_number"></item-view>
          <item-view label="Guidance Duration" :value="guidance.duration"></item-view>
          <item-view label="Guidance Type" :value="guidance.guidance_type"></item-view>
          <item-view label="Guidance Date" :value="guidance.date_range"></item-view>
          <item-view label="Port" :value="getPortName()"></item-view>
          <item-view label="Department" :value="getDepartmentName()"></item-view>
          <item-view label="Vendor" :value="getVendorName()"></item-view>
          <item-view label="Tariff" :value="getTariffName()"></item-view>
          <item-view label="Status">
            <span :class="`status-badge status-${state}`">{{ guidance.status }} </span>
          </item-view>
          <item-view label="Total Value" :value="formatCurrency(overallWorkItemsTotal())"></item-view>
          <item-view :label="'Total '+ payUnit()" :value="formatNumber(overallWorkItemsQty())"></item-view>
        </items-view>



        <items-view style="border:1px solid #CCCCCC" :title="'Other Form Details'" v-if="guidance.is_manual">
          <item-view label="" >
            <md-button class="md-raised md-primary" @click="openCreateWorkModal">
              <md-icon>add</md-icon>
              Add Working Vessel
            </md-button>
          </item-view>
        </items-view>

        <!-- Two Column Layout for Dashboard -->
        <div class="md-layout">
          <!-- Left Column: Statistics -->
          <div class="md-layout-item md-size-100">

            <!--        Start new design-->
            <div class="works-container">

              <div
                  v-for="work in works"
                  :key="work.id"
                  class="work-card"
              >

                <!-- WORK HEADER -->
                <div class="work-header">

                  <div>
                    <div class="work-title">
                    <span class="work-number">
                        {{ work.name  }}
                    </span>
                    </div>

                    <div class="work-information">

                     <span class="vessel-badge">
                        <md-icon>directions_boat</md-icon>
                        <strong>Vessel:</strong>
                        <span > {{ work.vessel?work.vessel.name : '-' }}</span>
                    </span>

                      <span v-if="work.date">
                        <md-icon>event</md-icon>
                        <strong>Date:</strong>
                        {{ work.date }}
                    </span>

                      <span>
                        <md-icon>list_alt</md-icon>
                        <strong>Items:</strong>
                        {{ work.items.length || 0 }}
                    </span>
                      <span>
        <md-icon>confirmation_number</md-icon>
        <strong>Call ID:</strong>
        {{ work.call_id || '-' }}
        </span>
                      <span>
                        <template v-if="guidance.pay_code==='PT'">
                          <md-icon>scale</md-icon>
                        </template>
                        <template v-else>
                          <md-icon>format_list_numbered</md-icon>
                        </template>

        <strong>{{payUnit()}}:</strong>
        {{ formatNumber(workQty(work))}}
        </span>
                      <span>
        <md-icon>money</md-icon>
        <strong>TOTAL:</strong>
        {{ formatCurrency(workTotal(work))}}
        </span>

                      <span class="work-actions">
  <md-button
      v-if="can('update-work') && guidance.status === ''&& work.allow_manual>0"
      class="md-raised work-action-btn work-edit"
      @click="openEditWorkModal(work)"
  >
    <md-icon>edit</md-icon>
    Edit
  </md-button>

  <md-button
      v-if="can('delete-work') && work.items.length===0 && guidance.status === ''"
      class="md-raised work-action-btn work-delete"
      @click="confirmDeleteWork(work)"
  >
    <md-icon>delete</md-icon>
    Delete
  </md-button>
</span>




                    </div>
                  </div>

                </div>


                <!-- ITEMS TABLE -->
                <div class="table-responsive">

                  <table class="table table-hover items-table">

                    <thead>
                    <tr>
                      <th width="40"></th>
                      <th>Item</th>
                      <th>Activity</th>
                      <th>Workplace</th>
                      <th>Unit</th>
                      <th>Quantity</th>
                      <th class="text-right">Amount</th>
                      <th>Sub Items</th>
                      <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody>

                    <template v-for="item in work.items">

                      <!-- ITEM -->
                      <tr
                          :key="item.id"
                          class="item-row"
                          @click="toggleItem(item.id)"
                      >

                        <td>
                          <md-icon>
                            {{
                              expandedItems.includes(item.id)
                                  ? 'expand_less'
                                  : 'expand_more'
                            }}
                          </md-icon>
                        </td>

                        <td>
                          <strong>
                            {{ item.name || '-' }}
                          </strong>
                        </td>

                        <td>
                          {{ item.activity?item.activity.name : '-' }}
                        </td>

                        <td>
                          {{ item.workplace?item.workplace.name : '-' }}
                        </td>

                        <td>
                          {{payUnit() }}
                        </td>
                        <td>
                          {{ formatNumber(workItemQty(item))}}
                        </td>
                        <td class="text-right">
                          <strong>
                            {{formatCurrency(workItemTotal(item))}}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{formatNumber(totalSubItems(item))}}
                          </strong>
                        </td>
                        <td class="actions-cell">
                          <span v-if="item.allow_manual===0">
                           <md-icon>block</md-icon>
                         </span>
                          <span v-else>
                          <md-icon>edit</md-icon>
                         </span>
                          <md-button
                              v-if="can('update-workItem') && guidance.status === ''"
                              class="md-icon-button md-round action-btn action-edit"
                              @click="openEditWorkItemModal(item, work)"
                              title="Edit"
                          >
                            <md-icon>edit</md-icon>
                          </md-button>

                          <md-button
                              v-if="can('delete-workItem') && guidance.status === '' && item.workDetails.length===0 "
                              class="md-icon-button md-round action-btn action-delete"
                              @click="deleteWorkItem(item)"
                              title="Delete"
                          >
                            <md-icon>delete</md-icon>
                          </md-button>
                        </td>


                      </tr>


                      <!-- WORK DETAILS -->
                      <tr
                          v-if="expandedItems.includes(item.id)"
                          :key="item.id + '-details'"
                          class="details-row"
                      >

                        <td colspan="9">

                          <div class="details-container">

                            <div class="details-title">
                              <md-icon>list_alt</md-icon>
                              Work Details
                            </div>

                            <table
                                v-if="item.workDetails.length"
                                class="table table-sm details-table"
                            >

                              <thead>
                              <tr>
                                <th>#</th>
                                <th>Item Number</th>
                                <th>Date</th>
                                <th>Shift</th>
                                <th> {{payUnit() }}</th>
                                <th>Amount</th>
                                <th>Remarks</th>
                                <th>Actions</th>
                              </tr>
                              </thead>

                              <tbody>

                              <tr
                                  v-for="(detail, index) in item.workDetails"
                                  :key="detail.id"
                              >
                                <td>{{ index + 1 }}</td>

                                <td>
                                  {{ detail.item_number || '-' }}
                                </td>
                                <td>
                                  {{ detail.date || '-' }}
                                </td>

                                <td>
                                  {{ detail.shift?detail.shift.name : '-' }}
                                </td>
                                <td>
                                  {{ workDetailQty(detail) || 0 }}
                                </td>

                                <td>{{formatCurrency(lineTotal(detail,item)) }}</td>

                                <td>
                                  {{ detail.remarks || '-' }}
                                </td>
                                <td class="actions-cell">
                                  <md-button
                                      v-if="can('update-workDetail') && guidance.status === ''"
                                      class="md-icon-button md-raised md-round action-btn action-edit"
                                      @click="openEditDetailModal(item, detail)"
                                      title="Edit"
                                  >
                                    <md-icon>edit</md-icon>
                                  </md-button>

                                  <md-button
                                      v-if="can('delete-workDetail') && guidance.status === ''"
                                      class="md-icon-button md-raised md-round action-btn action-delete"
                                      @click="deleteWorkItemDetail(detail)"
                                      title="Delete"
                                  >
                                    <md-icon>delete</md-icon>
                                  </md-button>
                                </td>

                              </tr>

                              </tbody>

                            </table>

                            <div
                                v-else
                                class="text-muted"
                            >
                              No work details available.
                            </div>

                          </div>

                        </td>

                      </tr>

                    </template>

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

            <!--        End New design-->

          </div>
        </div>
        <md-dialog :md-active.sync="showWorkItemModal">

          <md-dialog-title>

            <md-icon>
              {{ workItemMode === 'create' ? 'add' : 'edit' }}
            </md-icon>

            {{ workItemMode === 'create'
              ? 'Add Cargo Item'
              : 'Edit Cargo Item'
            }}
          </md-dialog-title>

          <md-dialog-content class="dialog-content">
            <md-card
                v-if="apiValidationErrors.general"
                class="md-danger"
                style="margin-bottom:15px;"
            >
              <md-card-content>
                {{ apiValidationErrors.general }}
              </md-card-content>
            </md-card>

            <div class="md-layout md-gutter">

              <!-- Date -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="section-label">Select Date
                  <small class="text-muted">
                    ( Allowed range:
                    {{ guidance.start_date }} - {{ guidance.end_date }})
                  </small>
                </label>

                <md-field :class="{ 'md-invalid': apiValidationErrors.date }">

                  <md-datepicker
                      v-model="workItem.date"
                      md-immediately
                      :md-disabled-dates="disabledDates"
                  >
                    <label>Select Date</label>
                  </md-datepicker>


                </md-field>
                <span class="md-error" v-if="apiValidationErrors.date">
          {{ apiValidationErrors.date }}
        </span>

              </div>

              <!-- Cargo Name -->
              <div class="md-layout-item md-size-50 md-small-size-100">
                <label class="section-label">
                  Cargo name
                </label>
                <md-field :class="{ 'md-invalid': apiValidationErrors.name }">


                  <md-input v-model="workItem.name" />

                  <span
                      v-if="apiValidationErrors.name"
                      class="md-error"
                  >
              {{ apiValidationErrors.name }}
              </span>
                </md-field>

              </div>

              <!-- Workplace -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="section-label">
                  Select Workplace
                </label>

                <select-input
                    v-model="workItem.workplace_id"
                    :options="allWorkplaces"
                    :error="apiValidationErrors.workplace_id"
                    track-by="id"
                    name="name"
                />

              </div>

              <!-- Activity -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="section-label">
                  Select Activity
                </label>

                <select-input
                    v-model="workItem.activity_id"
                    :options="activities"
                    :error="apiValidationErrors.activity_id"
                    track-by="id"
                    name="name"
                />

              </div>

            </div>

          </md-dialog-content>

          <md-dialog-actions>

            <md-button
                @click="showWorkItemModal = false"
            >
              Cancel
            </md-button>

            <md-button
                class="md-primary md-raised"
                @click="saveWorkItem"
            >
              <md-icon>
                {{ workItemMode === 'create'
                  ? 'add'
                  : 'save'
                }}
              </md-icon>

              {{ workItemMode === 'create'
                ? 'Create'
                : 'Update'
              }}
            </md-button>

          </md-dialog-actions>

        </md-dialog>

      </md-card-header>

      <!-- Action Buttons -->
      <div class="action-bar">
        <md-button class="md-dense md-raised md-secondary" @click="goBack">
          <md-icon>arrow_back</md-icon> Go Back
        </md-button>
      </div>

      <md-dialog :md-active.sync="showDetailModal">


        <md-dialog-title>
          {{ modalMode === 'edit' ? 'Edit Item Detail' : 'Add Item Detail' }}
        </md-dialog-title>

        <md-dialog-content>
          <div
              v-if="apiError"
              class="api-error text-left"
          >
            <md-icon>error_outline</md-icon>

            <span>{{ apiError }}</span>
          </div>

          <div class="md-layout md-gutter">

            <!-- Item / Ticket Number -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <label class="field-label">Item/Ticket Number</label>

              <md-field>
                <md-input
                    v-model="detailForm.item_number"
                />
              </md-field>
            </div>

            <!-- Shift -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <label class="field-label">Select Shift</label>

              <select-input
                  v-model="detailForm.shift_id"
                  :options="shifts"
                  track-by="id"
                  name="name"
              />
            </div>

            <!-- Commodity -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <label class="field-label">Commodity</label>

              <md-field>
                <md-input
                    v-model="detailForm.commodity"
                />
              </md-field>
            </div>

            <!-- Quantity -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <label class="field-label">
                {{ payUnit() }}
              </label>

              <md-field>
                <md-input
                    v-model="detailForm.quantity"
                    type="number"
                    min="0"
                />
              </md-field>
            </div>

            <!-- Remarks -->
            <div class="md-layout-item md-size-100">
              <label class="field-label">Remarks</label>

              <md-field>
                <md-textarea
                    v-model="detailForm.remarks"
                    rows="3"
                />
              </md-field>
            </div>

          </div>

        </md-dialog-content>

        <md-dialog-actions>

          <md-button
              @click="showDetailModal = false"
          >
            Cancel
          </md-button>

          <md-button
              class="md-primary"
              @click="saveDetail"
          >
            {{ modalMode === 'edit' ? 'Update' : 'Save' }}
          </md-button>

        </md-dialog-actions>

      </md-dialog>
      <md-dialog :md-active.sync="showWorkModal">

        <md-dialog-title>
          <md-icon>
            {{ workMode === 'create' ? 'add' : 'edit' }}
          </md-icon>

          {{ workMode === 'create'
            ? 'Add Work'
            : 'Update Vessel Details'
          }}
        </md-dialog-title>

        <md-dialog-content>

          <div class="md-layout">

            <!-- Vessel -->
            <div class="md-layout-item md-size-100 md-gutter">
              <select-input
                  v-model="selectedVessel"
                  :options="vessels"
                  track-by="id"
                  label="Vessel"
                  name="name"
                  placeholder="Select vessel"
              />
              <md-field :class="{ 'md-invalid': apiValidationErrors.vessel_id }">
                <span
                    v-if="apiValidationErrors.vessel_id"
                    class="md-error"
                >
              {{ apiValidationErrors.vessel_id }}
              </span>
              </md-field>
            </div>

            <!-- Category -->
            <div class="md-layout-item md-size-100">

              <select-input
                  v-model="work.name"
                  :options="itemCategories"
                  track-by="name"
                  name="name"
                  label="Category"
                  placeholder="Select Cargo type"
              />
              <md-field :class="{ 'md-invalid': apiValidationErrors.name }">
              <span
                  v-if="apiValidationErrors.name"
                  class="md-error"
              >
              {{ apiValidationErrors.name }}
              </span>
              </md-field>
            </div>

            <!-- Call ID -->
            <div class="md-layout-item md-size-100">
              <md-field :class="{ 'md-invalid': apiValidationErrors.call_id }">
                <label>Call ID</label>

                <md-input v-model="work.call_id" />

                <span
                    v-if="apiValidationErrors.call_id"
                    class="md-error"
                >
              {{ apiValidationErrors.call_id }}
              </span>
              </md-field>
            </div>

          </div>

        </md-dialog-content>

        <md-dialog-actions>

          <md-button @click="showWorkModal = false">
            Cancel
          </md-button>

          <md-button
              class="md-primary"
              @click="saveWork"
          >
            {{ workMode === 'create' ? 'Create' : 'Update' }}
          </md-button>

        </md-dialog-actions>

      </md-dialog>

    </div>
    <!-- Status Change Modal -->
  </md-card>
</template>

<script>
// import { ValidationError } from '@/components';
import guidanceStatisticsMixin from '@/mixins/guidance-statistics-mixin';
import formMixin from '@/mixins/form-mixin';
import Swal from 'sweetalert2';
import ItemsView from '../../../../components/Inputs/ItemsView';
import ItemView from '../../../../components/Inputs/ItemView';
import SelectInput from '@/components/Inputs/SelectInput.vue';
import {Modal, ValidationError} from "@/components";
import Vuex from "vuex";
import Multiselect from "vue-multiselect";
import 'vue-multiselect/dist/vue-multiselect.min.css'
// import GuidanceStatisticPanel from "@/pages/settings/guidances/components/GuidanceStatisticPanel.vue";

export default {
  name: 'ManageGuidanceShiftPage',
  components: {
    SelectInput,
    Multiselect,
    ValidationError, Modal,
    ItemView,
    ItemsView,
    // GuidanceStatisticPanel
  },
  mixins: [formMixin,guidanceStatisticsMixin],
  data() {
    return {
      apiError: null,
      isInitializing: false,
      itemCategories: [
        { id: 1, name: 'Containerized Cargo' },
        { id: 2, name: 'Dry Bulk Cargo' },
        { id: 3, name: 'Break Bulk Cargo' },
        { id: 4, name: 'Liquid Bulk Cargo' },
        { id: 5, name: 'General Cargo' },
        { id: 6, name: 'Bagged Cargo' },
        { id: 7, name: 'Ro-Ro Cargo' },
        { id: 8, name: 'Hazardous Cargo' },
        { id: 9, name: 'Livestock' },
        { id: 10, name: 'Oversized Cargo' },
        { id: 11, name: 'Lo-Lo Cargo' },
      ],
      state:"",
      expandedItems: [],
      showTicketPreview: false,
      showCategorySelect: false,
      modal: {
        classicModal: false,
      },
      roles: [],
      allPermissions: [],
      status: {
        name: null,
        reason: null,
      },
      ticketPreview: null,
      previewLoading: false,
      reject: false,
      selectedStatus: null,
      expandedWorkItems: {},
      activeTariff: {},
      selected_shifts: [],
      backup_shifts: [],
      activities:[],
      allWorkplaces: [],
      editableWorkPoint: '',
      shifts: [],
      vessels: [],
      workPoints: [],
      workPoint:null,
      showWorkForm: false,
      showWorkModal: false,
      workMode: 'create',
      work: {
        id: null,
        guidance_id: null,
        name: '',
        call_id: '',
        vessel_id: null
      },
      selectedVessel: null,
      workItem:{
        name:null,
        activity_id:null,
        workplace_id:null,
        date:null,
      },
      showWorkItemModal: false,

      workItemDetails: {},
      showForms: {},
      editMode: {},
      editingDetail: {},

      payload:{},

      guidance: {
        id: null,
        name: null,
        guidance_number: null,
        duration: null,
        date_range: null,
        port: null,
        department: null,
        vendor: null,
        tariff: null,
        status: null
      },
      id: '',
      isLoading: false,
      exceptionSaving: false,
      visibleExceptions: {},
      showDetailModal: false,
      modalMode: 'create', // create | edit
      selectedWorkItem: null,
      workItemMode:'create',
      detailForm: {
        id: null,
        item_number: '',
        date: null,
        shift_id: null,
        commodity: '',
        item_type: '',
        category: null,
        quantity: null,
        remarks: ''
      },
      holidays:[],


    };
  },
  watch: {
    'guidance.status': {
      immediate: true,

      handler(newStatus) {
        if (newStatus === 'Accepted') {
          this.state = 'accepted'
        } else if (newStatus === 'Approved') {
          this.state = 'success'
        } else if (newStatus === 'Confirmed') {
          this.state = 'warning'
        } else if (newStatus === 'Certified') {
          this.state = 'info'
        } else if (newStatus === 'Reviewed') {
          this.state = 'purple'
        } else if (newStatus === 'Created') {
          this.state = 'primary'
        } else {
          this.state = 'default'
        }
      }
    },
    'workItem.workplace_id'(workplaceId) {
      // Don't reset activity while loading existing data
      if (!this.isInitializing) {
        this.workItem.activity_id = null;
      }
      const workplace = this.allWorkplaces.find(
          w => w.id == workplaceId
      );

      this.activities = workplace
          ? workplace.activities
          : [];

      this.isInitializing=false;
    },
    'workItem.activity_id'(activityId) {
      const workplace = this.allWorkplaces.find(
          w => w.activities?.some(
              activity => activity.id == activityId
          )
      );

      this.activities = workplace
          ? workplace.activities
          : [];
    },
  },
  computed: {
    works() {
      return this.guidance && this.guidance.works
          ? this.guidance.works
          : [];
    },

    selectedActivity() {
      return this.activities.find(
          activity => activity.id === this.workItem.activity_id
      ) || null;
    },


    isManualActivity() {
      return this.guidance?.allow_manual;
    },

    quantityUnit() {
      if (!this.selectedActivity) {
        return 'Number';
      }

      switch (this.selectedActivity.pay_code) {
        case 'PU':
          return 'Quantity';

        case 'TU':
          return 'TEUs';
        case 'PT':
          return 'Tonnage';

        default:
          return 'Number';
      }
    },
    ...Vuex.mapState({
      me: state => state.profile.me
    }),

  },

  created: function() {
    this.initialize();
    this.publicHolidays();
  },

  methods: {

    toggleItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);

      if (index === -1) {
        this.expandedItems.push(itemId);
      } else {
        this.expandedItems.splice(index, 1);
      }
    },

    isItemExpanded(itemId) {
      return this.expandedItems.includes(itemId);
    },


    formatDate(date) {
      if (!date) {
        return '-';
      }

      return moment(date).format('DD/MM/YYYY');
    },


    //===========================
    formatDateTime: function (dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString();
    },
    async confirmDeleteWork(work) {
      const result = await Swal.fire({
        title: 'Delete Work?',
        text: 'This will permanently delete the work record.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#d33',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        await this.$store.dispatch('works/destroy', work.id);

        const index = this.guidance.works.findIndex(
            w => w.id === work.id
        );

        if (index !== -1) {
          this.guidance.works.splice(index, 1);
        }

        this.openedWorkId = null;

        this.notifySuccess('Work deleted successfully.');

      } catch (e) {

        const error = e.response?.data?.errors?.[0];

        const message =
            error?.title ||
            error?.detail ||
            e.response?.data?.message ||
            'Failed to delete work.';

        this.notifyError(message);

        // Optional: populate validation/general errors if your form uses them
        if (e.response?.data?.errors) {
          this.setApiValidation(e.response.data.errors);
        }

        console.error(e);
      }
    },
    openCreateWorkModal() {
      this.workMode = 'create';

      this.work = {
        id: null,
        guidance_id: this.guidance.id,
        name: '',
        call_id: '',
        vessel_id: null
      };

      this.selectedVessel = null;
      this.showWorkModal = true;
      this.apiValidationErrors = {};
    },

    openEditWorkModal(work) {
      this.workMode = 'edit';

      this.work = Object.assign({}, work);
      this.work.vessel_id=work.vessel;

      this.selectedVessel = work.vessel.id || null;

      this.showWorkModal = true;
      this.apiValidationErrors = {};
    },
    async saveWork() {
      this.apiValidationErrors = {};

      try {
        if (this.work.id) {
          // UPDATE

          const vessel = this.vessels.find(
              item => item.id === this.selectedVessel
          );

          if(vessel){
            this.work.vessel_id=vessel.id;
          }else{
            this.work.vessel_id=null;
          }
          const response = await this.$store.dispatch('works/update', {
            type: 'works',
            id: String(this.work.id),
            guidance_id: this.guidance.id,
            name:this.work.name,
            call_id: this.work.call_id,
            vessel_id: this.work.vessel_id,
          });

          console.log(response);
          this.work = response;
          this.showWorkModal = false;
          this.$store.dispatch(
              'alerts/success',
              'Work updated successfully.'
          );

        } else {
          // CREATE
          const response = await this.$store.dispatch('works/add', {
            type: 'works',
            guidance_id: this.guidance.id,
            name: this.work.name,
            call_id: this.work.call_id,
            vessel_id: this.work.vessel_id
          });

          this.work = response;

          if (!this.guidance.works.find(w => w.id === response.id)) {
            this.guidance.works.push(response);
          }

          this.showWorkModal = false;

          this.$store.dispatch(
              'alerts/success',
              'Work added successfully.'
          );
        }
      } catch (error) {
        // JSON:API validation errors
        if (error.response && error.response.status === 422) {
          this.apiValidationErrors = {};

          error.response.data.errors.forEach(err => {
            const field = err.source?.pointer?.split('/').pop();

            if (field) {
              this.apiValidationErrors[field] = err.detail;
            }
          });

          return;
        }
console.log(error);
        // Other errors
        const message =
            error.response?.data?.errors?.[0]?.detail ||
            error.response?.data?.errors?.[0]?.title ||
            'An unexpected error occurred.';

        this.$store.dispatch('alerts/error', message);
      }finally {
this.getGuidance();
      }
    },

    disabledDates(date) {
      const selected = new Date(date);

      const start = new Date(this.guidance.start_date);
      const end = new Date(this.guidance.end_date);

      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      return selected < start || selected > end;
    },
    hasWorkDetails: function () {
      return this.guidance.workItems.length > 0 &&
          this.guidance.workItems[0] &&
          this.guidance.workItems[0].workItemDetails &&
          this.guidance.workItems[0].workItemDetails.length > 0;
    },
    canShowStatusButton: function (status, index) {
      console.log(this.hasWorkDetails )

      if (index === 0) {
        return this.can('create-guidance-status') &&
            this.hasWorkDetails &&
            (this.guidance.status === '' || this.guidance.status === 'Rejected' || this.guidance.status === 'New');
      }
      var prevStatus = this.guidance.possibles[index - 1];
      return this.can(status.action.toLowerCase() + '-guidance-status') &&
          this.hasWorkDetails &&
          this.guidance.status === (prevStatus ? prevStatus.name : null);
    },

    classicModalHide: function () {
      this.modal.classicModal = false;
      this.reject = false;
      this.selectedStatus = null;
      this.status.reason = null;
    },
    creatorLabel: function (status) {
      if (!status) return '';
      var creator = status.creator;
      if (!creator) return status.creator_id || '';
      var model = creator.model;
      if (model) {
        var firstName = typeof model.first_name === 'string' ? model.first_name.trim() : '';
        var lastName = typeof model.last_name === 'string' ? model.last_name.trim() : '';
        var checkNo = model.check_no ? '<br>(C/N: ' + model.check_no + ')' : '';
        var fullName = [firstName, lastName].filter(Boolean).join(' ');
        if (fullName) return fullName + checkNo;
        if (checkNo) return 'Unknown User' + checkNo;
        return creator.name || 'Unknown User';
      }
      return creator.name || 'Unknown User';
    },

    toggleDetails(workItemId) {
      this.$set(
          this.expandedWorkItems,
          workItemId,
          !this.expandedWorkItems[workItemId]
      );
    },

    showDetails(workItemId) {
      return !!this.expandedWorkItems[workItemId];
    },

    payUnit() {
      const paycode = this.guidance.pay_code;
      if(paycode==='PT'){
        return 'Tonnage';
      }else if(paycode==='PU'){
        return 'Quantity';
      }else if(paycode==='TU'){
        return 'TEUs';
      }else{
        return paycode;
      }
    },
    rateWeekday(workItem) {
      return Number(workItem?.activityTariff?.amount || 0);
    },

    rateWeekend(workItem) {
      return Number(workItem?.activityTariff?.weekend_amount || 0);
    },
    overallWorkItemsTotal() {
      return (this.guidance?.workItems || []).reduce(
          (total, workItem) => total + this.workItemTotal(workItem),
          0
      );
    },
    overallWorkItemsQty() {
      return (this.guidance?.workItems || []).reduce(
          (total, workItem) => total + this.workItemQty(workItem),
          0
      );
    },
    workQty(work) {
      if (!work?.items?.length) {
        return 0;
      }

      return work.items.reduce(
          (total, item) => total + this.workItemQty(item),
          0
      );
    },


    workTotal(work) {
      return (work?.items|| []).reduce(
          (total, workItem) => total + this.workItemTotal(workItem),
          0
      );
    },
    workItemQty(workItem) {

      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.reduce((total, detail) => {
        const quantity = parseFloat(detail.quantity);
        const factor = parseFloat(detail.conversion_factor);

        if (!Number.isFinite(quantity) || !Number.isFinite(factor) || factor <= 0) {
          return total;
        }

        return total + (quantity / factor);
      }, 0);
    },
    totalSubItems(workItem) {
      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.length;
    },
    workDetailQty(detail) {
      const factor = Number(detail.conversion_factor) || 1;
      const quantity = Number(detail.quantity) || 0;

      return this.formatNumber(quantity / factor);
    },

    workItemTotal(workItem) {
      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.reduce((total, detail) => {
        return total + this.lineTotal(detail, workItem);
      }, 0);
    },

    lineTotal(detail, workItem) {
      const quantity = Number(this.workDetailQty(detail) || 0);

      if (!workItem?.activityTariff) {
        return 0;
      }

      // Public Holiday
      if (this.isPublicHoliday(detail.date)) {
        return quantity * Number(
            workItem.activityTariff.weekend_amount || 0
        );
      }

      const day = new Date(detail.date).getDay();

      // Weekend (Saturday = 6, Sunday = 0)
      if (day === 0 || day === 6) {
        return quantity * Number(
            workItem.activityTariff.weekend_amount || 0
        );
      }

      // Weekday
      return quantity * Number(
          workItem.activityTariff.amount || 0
      );
    },
    async publicHolidays() {
      try {
        await this.$store.dispatch('holidays/list');

        this.holidays = this.$store.getters['holidays/list'] || [];

        console.log(this.holidays);
        return this.holidays;

      } catch (error) {
        console.error('Failed to load public holidays:', error);

        this.holidays = [];

        return [];
      }
    },

    isPublicHoliday(date) {
      const workDate = new Date(date).toISOString().split('T')[0];

      return this.holidays.some(holiday => {
        const holidayDate = new Date(holiday.holiday_date)
            .toISOString()
            .split('T')[0];

        return holidayDate === workDate;
      });
    },

    openEditWorkItemModal(workitem,work) {
      this.workItemMode = 'edit';
      this.isInitializing = true;
console.log(workitem);
console.log('after load');
      this.workItem = {
        id: workitem.id,
        date: workitem.date,
        name: workitem.name,
        workplace_id: workitem.workplace.id,
        activity_id: workitem.activity.id,
        work_id: work.id
      };
this.activities
console.log( this.workItem );
      this.showWorkItemModal = true;
      //this.isInitializing = false;
    },
    openCreateWorkItemModal(work) {
      this.workItemMode = 'create';

      this.workItem = {
        id: null,
        date: null,
        name: '',
        workplace_id: null,
        activity_id: null,
        work_id: work.id
      };

      this.showWorkItemModal = true;
    },


    async saveWorkItem() {
      try {

        if (this.workItemMode === 'create') {
          const { id, ...payload } ={
            type: 'workItems',
            guidance_id:this.guidance.id,
            ...this.workItem
          };

          const selected = new Date(payload.date);
          const start = new Date(this.guidance.start_date);
          const end = new Date(this.guidance.end_date);
          // Remove the time portion
          selected.setHours(0, 0, 0, 0);
          start.setHours(0, 0, 0, 0);
          end.setHours(0, 0, 0, 0);

          if (selected < start || selected > end) {
            this.apiValidationErrors.date =
                'The selected date must be within the guidance date range.';
            return;
          }

          this.apiValidationErrors.date = null;

          await this.$store.dispatch('workItems/add',payload );

          this.notifySuccess('Cargo Item added successfully.');

        } else {
console.log(this.workItem);
          await this.$store.dispatch('workItems/update', {
            id: this.workItem.id,
            guidance_id:this.guidance.id,
            type: 'workItems',
            activity_id:this.workItem.activity_id,
            workplace_id:this.workItem.workplace_id,
            date:this.workItem.date,
            work_id:this.workItem.work_id,
            name:this.workItem.name,
            //...this.workItem
          });

          this.notifySuccess('Cargo Item updated successfully.');
        }

        await this.getGuidance();

        this.showWorkItemModal = false;

      } catch (e) {
        console.log(e.response);
        if (e.response?.data?.errors?.length) {
          this.setApiValidation(e.response.data.errors);
          this.notifyError(e.response.data.errors[0].detail);
        }
      }
    },
    async deleteWorkItem(workitem) {

      const result = await Swal.fire({
        title: 'Delete Cargo Item?',
        text: `You are about to delete "${workitem.name}".`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {

        await this.$store.dispatch(
            'workItems/destroy',
            workitem.id
        );

        this.notifySuccess(
            'Cargo Item deleted successfully.'
        );

        await this.getGuidance();

      } catch (e) {
        this.notifyError(
            e.response?.data?.errors?.[0]?.detail ||
            'Unable to delete work item.'
        );
        // this.notifyError(
        //     'Failed to delete Cargo Item.'
        // );
      }
    },
    openAddDetailModal(workitem) {

      this.modalMode = 'create';

      this.selectedWorkItem = workitem;

      this.detailForm = {
        id: null,
        item_number: '',
        date: null,
        shift_id: null,
        commodity: '',
        item_type: '',
        quantity: null,
        remarks: ''
      };

      this.showDetailModal = true;
    },
    openEditDetailModal(workitem, detail) {

      this.modalMode = 'edit';

      this.selectedWorkItem = workitem;

      this.detailForm = {
        id: detail.id,
        item_number: detail.item_number,
        date: detail.date,
        shift_id: detail.shift.id,
        commodity: detail.commodity,
        item_type: detail.item_type,
        quantity: detail.quantity,
        remarks: detail.remarks
      };
console.log(this.detailForm);
console.log("yahaya");
console.log(detail);
      this.showDetailModal = true;
    },
    async saveDetail() {
      try {
        if (this.modalMode === 'edit') {

          const payload = {
            type: 'workDetails',
            work_item_id: this.selectedWorkItem.id,
            ...this.detailForm
          };

          console.log('UPDATE PAYLOAD:', payload);

          await this.$store.dispatch(
              'workDetails/update',
              payload
          );
this.apiError=null;
          this.notifySuccess('Item detail updated successfully.');

        } else {

          const { id, ...payload } = {
            type: 'workDetails',
            ...this.detailForm,
            work_item_id: this.selectedWorkItem.id
          };

          console.log('ADD PAYLOAD:', payload);

          await this.$store.dispatch(
              'workDetails/add',
              payload
          );

          this.notifySuccess('Item detail added successfully.');
        }

        this.showDetailModal = false;

        await this.getGuidance();

      } catch (e) {
        console.log('FULL ERROR:', e);
        console.log('FULL ERROR:', e);
        console.log('STATUS:', e?.response?.status);
        console.log('DATA:', e?.response?.data);
        console.log('ERRORS:', e?.response?.data?.errors);

        const errors = e?.response?.data?.errors || [];

        if (errors.length) {
          this.apiError = errors[0].detail;
        } else {
          this.apiError = 'Unable to save item detail.';
        }

        if (errors.length) {
          this.setApiValidation(errors);
        } else {
          this.notifyError('Unable to save item detail.');
        }
      }
    },
    async deleteWorkItemDetail(detail) {
      const result = await Swal.fire({
        title: 'Delete Item Detail?',
        text: `Item Number: ${detail.item_number}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#e53935',
        reverseButtons: true
      });

      if (!result.isConfirmed) {
        return;
      }
      try {

        await this.$store.dispatch('workDetails/destroy', detail.id);

        await this.getGuidance(); // reload guidance/workitems

        this.notifySuccess('Item detail deleted successfully.');
        Swal.fire({
          title: 'Deleted!',
          text: 'Item detail has been deleted successfully.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (e) {
        this.notifyError('Failed to delete item detail.');
        Swal.fire({
          title: 'Error',
          text: 'Failed to delete item detail.',
          icon: 'error'
        });
        console.error(e);
      }
    },
    initWorkItemDetails() {
      this.guidance.workItems.forEach(item => {
        this.$set(this.workItemDetails, item.id, {
          item_number: '',
          date: null,
          shift_id: null,
          commodity: '',
          item_type: '',
          quantity: null,
          remarks: ''
        });
      });
    },
    initialize: async function() {
      var self = this;
      self.isLoading = true;
      try {
        await self.getGuidance();
        await self.getWorkplaces();
        await self.getVessels();
        await self.getShifts();
        // await self.getTariff();
        // self.processGuidanceWorkplaces();
      } catch (error) {

        self.notifyError('Failed to load page data');
      } finally {
        self.isLoading = false;
      }
    },

    getPortName: function() {
      return this.guidance.port ? this.guidance.port.name : '';
    },

    getDepartmentName: function() {
      return this.guidance.department ? this.guidance.department.name : '';
    },

    getVendorName: function() {
      return this.guidance.vendor ? this.guidance.vendor.name : '';
    },

    getTariffName: function() {
      return this.guidance.tariff ? this.guidance.tariff.name : '';
    },
    goBack: function () {
      this.$router.push({name: 'Manage Guidance Work Item'});
    },

    getGuidance: async function() {
      var self = this;
      var id = this.$route.params.id;
      this.id = id;

      var params = {
        id: id,
        include: 'port,department,tariff,' +
            'guidanceWorkplaces.workplace.activities,' +
            'workItems.workplace,workItems.activity,' +
            'workItems.activityTariff,' +
            'workItems.workDetails,' +
            'works,' +
            'works.items,' +
            'works.items.activityTariff,' +
            'works.items.activity,' +
            'works.items.workplace,' +
            'works.items.workDetails,' +
            'works.items.workDetails.shift,' +
            'works.vessel,' +
            'workItems.workDetails.shift,' +
            'guidanceWorkplaces.activityGuidances.activity,' +
            'guidanceWorkplaces.activityGuidances.exceptions,' +
            'guidanceWorkplaces.activityGuidances.activityShifts.shift,' +
            'guidanceWorkplaces.activityGuidances.activityTariff,' +
            'guidanceWorkplaces.activityGuidances.exceptions.activity,' +
            'guidanceWorkplaces.activityGuidances.exceptions.activityShifts.shift'
      };

      await this.$store.dispatch('guidances/view', params);
      this.guidance = this.$store.getters['guidances/guidance'];
      // Convert database 1/0 to boolean
      this.guidance.allow_manual =
          Boolean(Number(this.guidance.allow_manual))
      // if (this.guidance && this.guidance.work) {
      //   Object.assign(this.work, this.guidance.work);
      //   this.selectedVessel=this.work.vessel.id;
      // }


      this.initWorkItemDetails();

      // if (this.guidance.status !== '' && this.guidance.status !== 'Created') {
      //   Swal.fire('Reviewed Guidance', 'You cannot modify reviewed Guidance', 'info');
      //   self.goBack();
      // }
    },

    getWorkplaces: async function () {
      console.log('guidance:', this.guidance);
      console.log('vendor_id:', this.guidance && this.guidance.vendor.d);

      await this.$store.dispatch('workplaces/list', {
        include: 'activities',
        filter: {
          pay_codes: 'PU,TU,PT',
          vendor: this.guidance.vendor.id
        }
      });
      this.allWorkplaces = this.$store.getters['workplaces/list'] || [];
      console.log('allWorkplaces:', this.allWorkplaces);
    },

    getVessels: async function() {
      await this.$store.dispatch('vessels/list');
      const vessels= this.$store.getters['vessels/dropdown'] || [];
      console.log(vessels);
      this.vessels=vessels;

    },

    getShifts: async function() {
      var self = this;
      await this.$store.dispatch('shifts/list',{filter:{is_active:'1'}});
      this.shifts = this.$store.getters['shifts/list'] || [];

      var shiftParams = { filter: { guidance: this.id } };
      await this.$store.dispatch('shifts/list', shiftParams);
      this.selected_shifts = this.$store.getters['shifts/list'] || [];
      this.backup_shifts = JSON.parse(JSON.stringify(this.selected_shifts));

      // Ensure all activities have shifts for selected shifts
      this.workPoints.forEach(function(wp) {
        wp.activities.forEach(function(activity) {
          self.ensureActivityShifts(activity);
        });
      });
    },


    ensureActivityShifts: function(activity) {
      var self = this;
      if (!activity.activity_shifts) {
        activity.activity_shifts = [];
      }

      this.selected_shifts.forEach(function(shift) {
        // Check by shift.id (UUID) instead of shift_id
        var existing = activity.activity_shifts.find(function(s) {
          return s.shift && s.shift.id === shift.id;
        });

        if (!existing) {
          activity.activity_shifts.push({
            shift_id: shift.id,
            shift: shift,
            labourer_count: 0,
            request_type: 'Open',
            day_type: activity.day_type || 'Weekday'
          });
        }
      });
    },

    removeActivity: async function(wpIndex, actIndex) {
      var self = this;
      var result = await Swal.fire({
        title: 'Remove Activity?',
        text: 'Are you sure you want to remove this activity?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove',
        cancelButtonText: 'Cancel'
      });

      if (!result.value) return;

      var activity = this.workPoints[wpIndex].activities[actIndex];

      try {
        if (activity.id) {
          await this.$store.dispatch('activityGuidances/destroy', activity.id);
        }

        this.workPoints[wpIndex].activities.splice(actIndex, 1);
        this.notifySuccess('Activity removed successfully');
        this.updateAllTotals();
      } catch (error) {
        this.notifyError('Error removing activity:', error);
        this.handleApiError(error);
      }
    },


    handleApiError: function(error) {
      if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
        var apiError = error.response.data.errors[0];
        this.notifyError(apiError.title || apiError.detail || 'An error occurred');
        this.setApiValidation(error.response.data.errors);
      } else {
        this.notifyError('An unexpected error occurred. Please try again.');
      }
    },

    formatCurrency: function(amount) {
      if (amount === undefined || amount === null) return 'TZS 0';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'TZS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    },

    formatNumber: function(number) {
      if (number === undefined || number === null) return '0';
      return new Intl.NumberFormat('en-US').format(number);
    },
    goToEdit(id) {
      this.$router.push({name: 'Edit Guidance', params: {id}});
    },


    // Status helpers
    isStatusCompleted: function (statusName) {
      if (!this.guidance.statuses) return false;
      return this.guidance.statuses.some(function (s) {
        return s.name === statusName;
      });
    },
    formatDateShort: function (dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString();
    },

    async saveAllowManual() {
      try {
        this.isLoading = true;

        const response = await this.$store.dispatch(
            'guidances/updateAllowManual',
            {
              id: this.guidance.id,
              allow_manual: this.guidance.allow_manual
            }
        );

        await this.$store.dispatch(
            'alerts/success',
            response.message
        );

      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Unable to update manual entry setting.'
        );
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.section-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.help-text {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.action-bar, .action-bar-bottom {
  display: flex;
  gap: 10px;
  margin: 15px;
  justify-content: flex-end;
}

.workpoint-card {
  margin: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.workpoint-card-content {
  padding: 0;
}

.workpoint-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.workpoint-header h4 {
  margin: 0;
  color: #333;
}

.activities-section {
  padding: 15px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.warning-box {
  background: #fff3e0;
  border-left: 4px solid #ff9800;
  padding: 12px;
  margin-bottom: 15px;
  color: #e65100;
  font-size: 14px;
}

.empty-activities {
  text-align: center;
  padding: 40px;
  color: #999;
}

.empty-activities md-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}

.shift-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
}

.shift-field {
  margin: 0;
  padding: 0;
  flex: 1;
}

.shift-field .md-input {
  font-size: 14px;
  padding: 8px;
  text-align: center;
}

.provision-checkbox {
  margin: 0 !important;
  transform: scale(0.8);
}

.action-buttons {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
}

.saved-badge {
  font-size: 11px;
  color: #4caf50;
  background: #e8f5e9;
  padding: 2px 6px;
  border-radius: 4px;
}

.shift-time {
  display: block;
  font-size: 10px;
  color: #666;
  font-weight: normal;
}

.table-footer-row {
  background-color: #f5f5f5;
  font-weight: bold;
}

.cell-50 {
  min-width: 250px;
}

.cell-10 {
  min-width: 100px;
}

.md-button.md-small {
  height: 32px;
  min-height: 32px;
  font-size: 12px;
  padding: 0 12px;
}

.md-button.md-small .md-icon {
  font-size: 18px;
  line-height: 18px;
}

.mt-4 {
  margin-top: 16px;
}

.exception-count {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff9800;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.md-button {
  position: relative;
}

.md-button.md-danger .exception-count {
  background-color: #fff;
  color: #f44336;
}
.full-width-item {
  width: 100%;
  max-width: 100%;
}

.full-width-container {
  width: 100%;
}

.full-width-table {
  width: 100% !important;
  table-layout: fixed; /* important for full stretch */
}

.md-card-content {
  width: 100%;
}
.form-container {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafafa;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.work-item-card {
  margin-bottom: 20px;
  border-radius: 12px;
}

.card-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-total {
  font-size: 18px;
  font-weight: bold;
  color: #1976d2;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 768px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.md-card {
  border-radius: 10px;
}

.md-card-header {
  background: #f5f7fa;
  border-bottom: 1px solid #eee;
}

.md-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.md-field {
  margin-top: 12px;
}

.multiselect {
  min-height: 48px;
}

.md-caption {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-weight: 600;
}
.ticket-preview {
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-top: 15px;
}

.ticket-preview-header {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  background: #fafafa;
}

.ticket-preview-header h3 {
  margin: 0;
  font-size: 18px;
}

.ticket-preview-body {
  padding: 20px;
}

.preview-section {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
}

.preview-field {
  padding: 8px 15px;
}

.preview-value {
  margin-top: 5px;
  font-size: 15px;
  color: #333;
}
.form-details-card {
  background: #ffffff;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  padding: 20px 24px;
  margin: 15px 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  color: #212529;
}

.form-details-card label,
.form-details-card strong,
.form-details-card p,
.form-details-card span {
  color: #212529;
}

.form-details-card small,
.form-details-card .text-muted {
  color: #6c757d !important;
}

.form-details-card .md-field {
  background: #ffffff;
}

.form-details-card input,
.form-details-card textarea {
  color: #212529 !important;
}
.form-hint {
  display: block;
  margin-bottom: 6px;
  color: #008800 !important;
  font-weight: 500;
}
.ticket-preview-dialog {
  width: 90%;
  max-width: 1200px;
}

.ticket-preview {
  padding: 5px 10px;
}

.preview-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}

.preview-section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.preview-field {
  margin-bottom: 15px;
}

.preview-value {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 500;
}

.md-dialog-content {
  max-height: 75vh;
}

/* =========================================================
   WORKS / VESSEL / ITEMS TABLE
   ========================================================= */

.works-container {
  width: 100%;
}


/* ---------------------------------------------------------
   WORK CARD
   --------------------------------------------------------- */

.work-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}


/* ---------------------------------------------------------
   WORK HEADER
   --------------------------------------------------------- */

.work-header {
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.work-title {
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 16px;
  font-weight: 600;
}

.work-number {
  color: #343a40;
}


/* ---------------------------------------------------------
   WORK INFORMATION
   --------------------------------------------------------- */

.work-information {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  margin-top: 8px;

  font-size: 15px;
  font-weight: bold;
  color: #1976d2;;
}

.work-information span {
  display: inline-flex;
  align-items: center;
}

.work-information .md-icon {
  font-size: 17px !important;
  min-width: 18px;
  width: 18px;
  margin-right: 5px;
}


/* ---------------------------------------------------------
   ITEMS TABLE
   --------------------------------------------------------- */

.items-table {
  margin: 0;
  width: 100%;
}

.items-table thead th {
  background: #ffffff;
  border-top: 0;
  border-bottom: 1px solid #dee2e6;

  color: #6c757d;

  font-size: 13px;
  font-weight: 600;

  text-transform: uppercase;
  letter-spacing: .04em;

  padding: 12px 14px;
  white-space: nowrap;
}

.items-table tbody td {
  padding: 13px 14px;
  vertical-align: middle;

  border-top: 1px solid #f0f0f0;

  font-size: 15px;
}


/* ---------------------------------------------------------
   ITEM ROW
   --------------------------------------------------------- */

.item-row {
  cursor: pointer;
  transition: background-color .15s ease;
}

.item-row:hover {
  background: #f8f9fa;
}

.item-row > td:first-child {
  width: 45px;
  text-align: center;
}

.item-row .md-icon {
  font-size: 20px !important;
}


/* ---------------------------------------------------------
   ITEM NUMBER
   --------------------------------------------------------- */

.item-row td:nth-child(2) strong {
  font-weight: 600;
  color: #343a40;
}


/* ---------------------------------------------------------
   STATUS
   --------------------------------------------------------- */

.status-badge {
  display: inline-flex;
  align-items: center;

  padding: 4px 10px;

  border-radius: 20px;

  font-size: 11px;
  font-weight: 600;

  white-space: nowrap;
}

.status-success {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-warning {
  background: #fff8e1;
  color: #ef6c00;
}

.status-danger {
  background: #ffebee;
  color: #c62828;
}

.status-primary {
  background: #e3f2fd;
  color: #1565c0;
}
.status-info {
  background: #e0f7fa;
  color: #00838f;
}
.status-purple {
  background: #f3e5f5;
  color: #7b1fa2;
}
.status-accepted {
  background: #e0f2f1;
  color: #00695c;
}
.status-default {
  background: #eceff1;
  color: #546e7a;
}


/* ---------------------------------------------------------
   WORK DETAILS ROW
   --------------------------------------------------------- */

.details-row {
  background: #f8f9fa;
}

.details-row > td {
  padding: 0 !important;
  border-top: 0 !important;
}

.details-container {
  padding: 18px 25px 20px 65px;
}


/* ---------------------------------------------------------
   DETAILS TITLE
   --------------------------------------------------------- */

.details-title {
  display: flex;
  align-items: center;

  margin-bottom: 12px;

  font-size: 13px;
  font-weight: 600;

  color: #495057;
}

.details-title .md-icon {
  font-size: 18px !important;
  margin-right: 6px;
}


/* ---------------------------------------------------------
   DETAILS TABLE
   --------------------------------------------------------- */

.details-table {
  width: 100%;
  margin-bottom: 0;

  background: #ffffff;

  border: 1px solid #e2e5e8;
}

.details-table thead th {
  background: #f8f9fa;

  border-top: 0;
  border-bottom: 1px solid #dee2e6;

  color: #6c757d;

  font-size: 10px;
  font-weight: 600;

  text-transform: uppercase;

  padding: 9px 12px;
}

.details-table tbody td {
  padding: 9px 12px;

  font-size: 12px;

  border-top: 1px solid #f0f0f0;
}


/* ---------------------------------------------------------
   WORK COUNT
   --------------------------------------------------------- */

.work-count {
  display: inline-flex;
  align-items: center;

  padding: 5px 12px;

  border-radius: 20px;

  background: #eef1f4;

  color: #495057;

  font-size: 11px;
  font-weight: 600;
}


/* ---------------------------------------------------------
   RESPONSIVE
   --------------------------------------------------------- */

@media (max-width: 992px) {

  .work-header {
    align-items: flex-start;
  }

  .work-information {
    gap: 10px 15px;
  }

  .details-container {
    padding-left: 25px;
  }

}


@media (max-width: 768px) {

  .work-header {
    flex-direction: column;
    gap: 12px;
  }

  .work-information {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .items-table {
    min-width: 900px;
  }

  .details-table {
    min-width: 600px;
  }

}
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.vessel-select-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

.vessel-select {
  flex: 1;
  min-width: 0;
}

.add-vessel-btn {
  margin: 0 !important;
  white-space: nowrap;
  height: 40px;
}
.vessel-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;

  padding: 6px 12px;

  background: #eef4ff;
  color: #2457c5;

  border: 1px solid #cddcff;
  border-radius: 18px;

  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
}

.vessel-badge .md-icon {
  font-size: 18px !important;
  width: 18px;
  min-width: 18px;

  color: #f5a900 !important;
}
.action-buttons-vertical {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-workflow-btn {
  width: 100%;
  min-height: 42px;
  margin: 0 !important;
  border-radius: 6px !important;

  display: flex !important;
  align-items: center;
  justify-content: center;

  font-weight: 500;
  text-transform: none !important;

  transition: all 0.2s ease-in-out;

  .md-icon {
    margin-right: 8px;
    font-size: 19px !important;
    color: #fff !important;
  }

  &:hover {
    transform: translateY(-1px);
  }
}

/* Status transition buttons */
.action-status {
  background: #1976d2 !important;
  color: #fff !important;

  &:hover {
    background: #1565c0 !important;
    box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3) !important;
  }
}

/* Reject */
.action-reject {
  background: #e53935 !important;
  color: #fff !important;

  &:hover {
    background: #c62828 !important;
    box-shadow: 0 4px 10px rgba(229, 57, 53, 0.3) !important;
  }
}

/* Action page */
.action-page {
  background: #00897b !important;
  color: #fff !important;

  &:hover {
    background: #00695c !important;
    box-shadow: 0 4px 10px rgba(0, 137, 123, 0.3) !important;
  }
}
.action-park {
  background: #2196f3 !important;
}

.action-review {
  background: #9c27b0 !important;
}

.action-certify {
  background: #00bcd4 !important;
}

.action-confirm {
  background: #ff9800 !important;
}

.action-approve {
  background: #4caf50 !important;
}

.action-accept {
  background: #00695c !important;
}

/*Action buttons */
.actions-cell {
  white-space: nowrap;
  text-align: center;
}

.action-btn {
  width: 36px !important;
  min-width: 36px !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 3px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  transition: all 0.2s ease-in-out;

  .md-icon {
    color: #fff !important;
    font-size: 18px !important;
  }

  &:hover {
    transform: translateY(-2px);
  }
}

.action-edit {
  background: #1976d2 !important;

  &:hover {
    background: #1565c0 !important;
    box-shadow: 0 4px 10px rgba(25, 118, 210, 0.35) !important;
  }
}

.action-delete {
  background: #e53935 !important;

  &:hover {
    background: #c62828 !important;
    box-shadow: 0 4px 10px rgba(229, 57, 53, 0.35) !important;
  }
}
.work-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.work-action-btn {
  min-width: 120px;
  height: 40px;
  border-radius: 20px !important;
  margin: 0 !important;
  padding: 0 18px !important;
  font-weight: 500;
  text-transform: none !important;
  transition: all 0.2s ease-in-out;

  .md-icon {
    font-size: 18px !important;
    margin-right: 6px;
  }

  &:hover {
    transform: translateY(-2px);
  }
}

.work-edit {
  background: #1976d2 !important;
  color: #fff !important;

  .md-icon {
    color: #fff !important;
  }

  &:hover {
    background: #1565c0 !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  }
}

.work-delete {
  background: #e53935 !important;
  color: #fff !important;

  .md-icon {
    color: #fff !important;
  }

  &:hover {
    background: #c62828 !important;
    box-shadow: 0 4px 12px rgba(229, 57, 53, 0.3) !important;
  }
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
}
.api-error {
  display: flex;
  align-items:center;
  gap: 98px;

  margin-bottom: 16px;
  padding: 12px 16px;

  border: 1px solid #ef9a9a;
  border-radius: 4px;

  background: #ffebee;
  color: #c62828;

  font-size: 14px;
  line-height: 1.5;
}

.api-error .md-icon {
  color: #c62828;
}



</style>
